// Configuración principal
const config = {
  timeouts: {
    init: 1000,
    columnSwitch: 500
  },
  selectors: {
    filters: {
      container: '#positionfiltrosTopAllSite',
      reference: 'input[name="q"]',
      category: '#categoriasTopSelect',
      size: '#tallasTopSelect',
      color: '#colorTopSelect',
      button: '#encuentraTutalla'
    },
    menu: '.m-menu-drawer__navigation > li',
    products: '.m-collection-products'
  }
};

// Clase principal para manejar los filtros
class FilterManager {
  constructor() {
    this.elements = {};
    this.initialized = false;
  }

  init() {
    // Inicializar elementos
    this.elements = {
      reference: document.querySelector(config.selectors.filters.reference),
      category: document.getElementById('categoriasTopSelect'),
      size: document.getElementById('tallasTopSelect'),
      color: document.getElementById('colorTopSelect'),
      button: document.getElementById('encuentraTutalla')
    };

    if (!this.validateElements()) return false;

    this.setupEventListeners();
    this.updateInitialState();
    this.bindSearchClick(); // ← fuerza navegación segura al hacer clic
    return true;
  }

  validateElements() {
    return Object.values(this.elements).every(element => element !== null);
  }

  setupEventListeners() {
    // Event listeners para filtros
    ['category', 'size', 'color'].forEach(filter => {
      this.elements[filter]?.addEventListener('change', () => {
        this.elements.reference.value = '';
        this.updateURL();
      });
    });

    // Event listener para referencia
    this.elements.reference?.addEventListener('input', () => {
      if (this.elements.reference.value.trim()) {
        this.resetFilters();
      }
      this.updateURL();
    });
  }

  resetFilters() {
    ['category', 'size', 'color'].forEach(filter => {
      if (this.elements[filter]) this.elements[filter].value = '';
    });
  }

  // --- NUEVO: fuerza navegación del botón aunque otro script haga preventDefault
  bindSearchClick() {
    const a = this.elements.button;
    if (!a) return;

    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href')?.trim();
      if (!href) {
        e.preventDefault();
        console.warn('[#encuentraTutalla] href vacío o inválido');
        return;
      }
      // Forzar navegación controlada (evita bloqueos y valida URL)
      e.preventDefault();
      try {
        const finalURL = new URL(href, window.location.origin).toString();
        console.debug('[#encuentraTutalla] navegando a:', finalURL);
        window.location.assign(finalURL);
      } catch (err) {
        console.error('URL inválida:', href, err);
      }
    }, { passive: false });
  }

  updateURL() {
    let reference = this.elements.reference.value.trim();

    // --- Caso búsqueda por referencia ---
    if (reference) {
      if (/^\d+$/.test(reference)) reference = 'P' + reference; // anteponer P si solo números
      reference = reference.toUpperCase();

      const u = new URL('/search', window.location.origin);
      u.searchParams.set('options[unavailable_products]', 'show');
      //u.searchParams.set('sort_by', 'title-descending');
      u.searchParams.set('q', reference);

      this.elements.button.setAttribute('href', u.toString());
      return;
    }

    // --- Caso filtros (categoría / talla / color) ---
    const categoryVal = (this.elements.category?.value || '').trim();
    const size = (this.elements.size?.value || '').trim();
    const color = (this.elements.color?.value || '').trim();

    // Base URL: si category es absoluta úsala tal cual; si es relativa, combínala con origin;
    // si está vacía, usa la URL actual (pathname + search).
    let base;
    try {
      base = categoryVal
        ? new URL(categoryVal, window.location.origin) // acepta absoluta o relativa
        : new URL(window.location.pathname + window.location.search, window.location.origin);
    } catch {
      base = new URL(window.location.pathname + window.location.search, window.location.origin);
    }

    // Asegura sort_by=title-descending (sobrescribe si ya viene en la categoría)
    //base.searchParams.set('sort_by', 'title-descending');

    // Filtros
    if (size) base.searchParams.set('filter.v.option.tallas', size);
    if (color) {
      // Soporte para valores tipo "filter.v.option.color=Azul" o solo "Azul"
      if (color.includes('=')) {
        const [k, v] = color.split('=');
        if (k && v) base.searchParams.set(k, v);
      } else {
        base.searchParams.set('filter.v.option.color', color);
      }
    }

    this.elements.button.setAttribute('href', base.toString());
  }

  updateInitialState() {
    this.updateURL();
  }
}

// Clase para manejar la UI
class UIManager {
  static initializeDeviceDetection() {
    const isMobile = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(
      navigator.userAgent.toLowerCase()
    ) || window.innerWidth < 768;

    document.body.classList.add(isMobile ? 'data-browser-cel' : 'data-browser-pc');
    return isMobile;
  }
  static createCategorySelect() {
    const container = document.getElementById('filtrosCategtorias');
    if (!container) return;

    const select = document.createElement('select');
    select.id = 'categoriasTopSelect';
    select.name = 'categoriasTopSelect';
    select.className = 'm-product-option--node';

    // Agregar opción por defecto
    select.appendChild(this.createOption('', 'Categoría', true));

    // Agregar opciones del menú
    const menuItems = document.querySelectorAll(config.selectors.menu);
    menuItems.forEach(item => this.processMenuItem(item, select));

    const wrapper = document.createElement('div');
    wrapper.className = 'm-product-option m-product-option--dropdown';
    wrapper.appendChild(select);
    container.appendChild(wrapper);
  }
  static createOption(value, text, isDefault = false) {
    const option = document.createElement('option');
    option.value = value;
    option.textContent = text;
    if (isDefault) option.className = 'm-product-option--node';
    return option;
  }
  static processMenuItem(item, select) {
    const link = item.querySelector('a.m-menu-mobile__link');
    if (!link) return;

    select.appendChild(this.createOption(link.getAttribute('href'), link.textContent.trim()));

    const submenuItems = item.querySelectorAll('.m-submenu-mobile a');
    submenuItems.forEach(subItem => {
      select.appendChild(this.createOption(
        subItem.getAttribute('href'),
        `- ${subItem.textContent.trim()}`
      ));
    });
  }
  static initializeColumnSwitcher() {
    setTimeout(() => {
      const isMobile = document.body.classList.contains('data-browser-cel');
      const columnNumber = isMobile ? "1" : "4";
      const columnButton = document.querySelector(`.m-toolbar--column-switcher button[data-column="${columnNumber}"]`);
      if (columnButton) {
        columnButton.click();
        console.log(`Columna ${columnNumber} activada automáticamente`);
      }
    }, 1000); // Espera 1seg
  }
  static modificarEnlacesMenu() {
    const menuLinks = document.querySelectorAll('#m-menu-drawer a');
    menuLinks.forEach(link => {
      const href = link.getAttribute('href');
      if (href && !href.includes('shopify.com')) {
        const nuevaURL = `${href}${href.includes('?') ? '&' : '?'}`;
        link.setAttribute('href', nuevaURL);
      }
    });
  }
}

// inicialización
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(() => {
    UIManager.modificarEnlacesMenu();  // Llamar al método aquí
    UIManager.createCategorySelect();
    const filterManager = new FilterManager();
    if (filterManager.init()) {
      UIManager.initializeDeviceDetection();
      UIManager.initializeColumnSwitcher();
    }
  }, config.timeouts.init);
});

document.addEventListener("DOMContentLoaded", function () {
  const menuLinks = document.querySelectorAll(".m-header__menu .m-menu__link");
  menuLinks.forEach(link => {
    let href = link.getAttribute("href");
    if (href.includes("/collections/")) {
      // Añade el sort_by si no lo tiene
      if (!href.includes("sort_by=")) {
        href += (href.includes("?") ? "&" : "?") + "";
        link.setAttribute("href", href);
      }
    }
  });
});

const URL_PRECIOS = "https://script.google.com/macros/s/AKfycbyJy3zeBAV6_TFmHmz24putaaMI3kXq0SQNBz4BPuBf2v-H8n9AmGoMZEGKZkCFT3bi/exec";
const CACHE_KEY = "PRESTIA_PRICELIST";
const CACHE_MINUTES = 10;

async function obtenerPrecios() {
  let cache = sessionStorage.getItem(CACHE_KEY);
  if (cache) {
    let { data, expires } = JSON.parse(cache);
    if (Date.now() < expires) return data;
  }
  const precios = await fetch(URL_PRECIOS).then(r => r.json());
  sessionStorage.setItem(
    CACHE_KEY,
    JSON.stringify({
      data: precios,
      expires: Date.now() + CACHE_MINUTES * 60 * 1000
    })
  );
  return precios;
}

async function aplicarPreciosPrestia() {
  const precios = await obtenerPrecios();
  const mapPrecios = {};
  precios.forEach(obj => mapPrecios[obj.sku] = obj);

  function render() {
    document.querySelectorAll('.m-product-card__info').forEach(card => {
      const h3 = card.querySelector('.m-product-card__title');
      if (!h3) return;
      const link = h3.querySelector('.m-product-card__name');
      if (!link) return;
      const titulo = link.textContent.trim();
      const ref = titulo.split(' ')[0].trim().toUpperCase();
      const data = mapPrecios[ref];
      if (!data) return;

      // Busca SIEMPRE el contenedor de precio, no importa el contexto (colección, búsqueda, etc).
      // 31/08/2026: dejo de ser una tabla Bootstrap. prestia-guard.js sigue
      // ocultando/mostrando cada fila por su mismo id (#data_precio_*), y el
      // bloque completo se sigue mostrando/ocultando por closest('[data-prestia-price]')
      // -- ver prestia-guard.js, ya actualizado para buscar este contenedor
      // en vez de closest('table').
      let priceDiv = card.querySelector('.m-product-card__pricing[data-prestia-price]');
      if (!priceDiv) return;
      if (priceDiv.getAttribute('data-prestia')) return;

      priceDiv.innerHTML = `
        <div class="price-row price-row--mayorista" id="data_precio_mayorista">
          <span class="amount">${data.mayorista}</span>
          <span class="unit">COP · mayorista</span>
        </div>
        <div class="price-row price-row--sugerido" id="data_precio_detal">
          <span class="amount">${data.detal}</span>
          <span class="unit">COP · sugerido de venta</span>
        </div>
        <div class="price-row price-row--usd" id="data_precio_dolares">
          <span class="amount">${data.dolares}</span>
          <span class="unit">USD · referencial</span>
        </div>
      `;
      priceDiv.setAttribute('data-prestia', '1');
    });
  }

  // Ejecuta una vez para los primeros productos
  render();

  // Observa el DOM para nuevos productos cargados automáticamente
  const observer = new MutationObserver(mutations => {
    render();
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

// Ejecuta cuando la página esté lista
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', aplicarPreciosPrestia);
} else {
  aplicarPreciosPrestia();
}

(function(){
  if (
    window.location.pathname.includes('/collections') ||
    window.location.pathname.includes('/search')
  ) {

    //const referenciasRAI = ["P74499","P74481","P4002","P74497","P74519","P74516","P74511"];
    const referenciasRAI = ["P74511"];
    function marcarEntregaProductos(){
      document.querySelectorAll('#CollectionProductGrid .m-product-card__info').forEach(card => {
        // Evita duplicar. El tag ahora vive en .m-product-card__media (hermano
        // de este 'card'), asi que hay que chequear en el ancestro comun, no
        // en 'card' mismo -- si no, esto se re-ejecutaria en cada mutacion del
        // DOM y apilaria un badge nuevo cada vez.
        const raizExistente = card.closest('.m-product-card');
        if (raizExistente && raizExistente.querySelector('.entrega-programada-tag')) return;

        // Encuentra el título y referencia
        const titleEl = card.querySelector('.m-product-card__title .m-product-card__name');
        if(!titleEl) return;
        const referencia = (titleEl.textContent.trim().split(/\s+/)[0] || "").toUpperCase();

        if(/^P?\d{4,}/.test(referencia)) {
          // Crea el aviso
          const tag = document.createElement('div');
          tag.className = 'entrega-programada-tag';
          tag.style.fontWeight = 'bold';
          tag.style.fontSize = '13px';
          tag.style.marginBottom = '3px';

          if (referenciasRAI.includes(referencia)) {
            tag.textContent = 'Entrega programada';
            tag.classList.add('is-programada'); // 31/08: chip ambar via tokens del tema

            // Cambia .qty.verde a .qty.amarilla solo dentro de este producto
            card.querySelectorAll('.qty.verde').forEach(qtySpan => {
              qtySpan.classList.remove('verde');
              qtySpan.classList.add('amarilla');
            });

          } else {
            tag.textContent = 'Entrega inmediata';
            tag.style.color = "#198754";
            // (opcional: asegurarse que las qty sean verdes)
            card.querySelectorAll('.qty').forEach(qtySpan => {
              qtySpan.classList.remove('amarilla');
              qtySpan.classList.add('verde');
            });
          }
          // 01/09/2026: el badge baja al pie de la card, entre la cantidad
          // disponible y la lupa -- ya no va sobre la imagen ni arriba del
          // titulo. 'card' aca es .m-product-card__info; el pie
          // (.m-product-card__footer-prestia) es HERMANO suyo, asi que hay
          // que subir al ancestro comun .m-product-card para encontrarlo.
          const cardRoot = card.closest('.m-product-card');
          const slot = cardRoot ? cardRoot.querySelector('.prestia-delivery-slot') : null;
          if (slot) {
            slot.appendChild(tag);
          } else {
            const h3 = card.querySelector('.m-product-card__title');
            if (h3) h3.insertBefore(tag, h3.firstElementChild);
          }
        }
      });
    }

    // CSS amarillo para la clase 'amarilla'
    const style = document.createElement('style');
    style.innerHTML = `
      .qty.amarilla {
        background: #FFA500 !important;
        color: #000 !important;
        border-radius: 4px;
        font-weight: bold;
        padding: 1px 6px;
      }
    `;
    document.head.appendChild(style);

    document.addEventListener('DOMContentLoaded', marcarEntregaProductos);
    const observer = new MutationObserver(marcarEntregaProductos);
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

// Espera a que el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  // Selecciona todos los contenedores con galería
  document.querySelectorAll('.m-product-card__media.multimediaplus').forEach(function(media) {
    const imgLink = media.querySelector('a.m-product-card__link');
    const quickviewBtn = media.querySelector('button.m-product-quickview-button');
    if (imgLink && quickviewBtn) {
      imgLink.addEventListener('click', function(e) {
        e.preventDefault(); // evita cualquier acción por defecto
        quickviewBtn.click(); // simula el click
      });
    }
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Selecciona el input de referencia y el botón de buscar
  const inputReferencia = document.querySelector('input[name="q"]');
  const btnBuscar = document.getElementById('encuentraTutalla');

  if (inputReferencia && btnBuscar) {
    inputReferencia.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        btnBuscar.click();
      }
    });
  }

  // (Opcional) Para que cualquier input/select dispare búsqueda con Enter
  const filtros = document.querySelectorAll('#positionfiltrosTopAllSite input, #positionfiltrosTopAllSite select');
  filtros.forEach(input => {
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        btnBuscar.click();
      }
    });
  });
});

// en tu xcs_data.js (o script global que ya manipula el viewport)
window.addEventListener('load', () => {
  const meta = document.querySelector('meta[name="viewport"]') || (() => {
    const m = document.createElement('meta');
    m.setAttribute('name', 'viewport');
    document.head.appendChild(m);
    return m;
  })();
  meta.setAttribute(
    'content',
    'width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes'
  );
});

document.addEventListener('DOMContentLoaded', () => {
  const logo = document.querySelector('.m-header__logo a.m-logo__image');
  if (logo) {
    // Cambiar el href al path actual (pathname + query string)
    logo.setAttribute('href', window.location.pathname + window.location.search);
  }
});

// Resalta en amarillo lo que la persona busco, dentro de cada tarjeta de
// producto en /search. La busqueda de Shopify trae mas resultados de los que
// el termino sugiere (busca en tags, tipo, descripcion, no solo en el titulo
// visible), asi que esto marca visualmente donde aparece el termino en lo que
// SI se ve, para que quede claro por que ese producto salio en la lista.
(function () {
  if (!window.location.pathname.includes('/search')) return;

  const termino = new URLSearchParams(window.location.search).get('q');
  if (!termino || !termino.trim()) return;

  function escaparRegex(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  const patron = new RegExp('(' + escaparRegex(termino.trim()) + ')', 'gi');

  function resaltarEnNodo(nodo) {
    if (nodo.nodeType === Node.TEXT_NODE) {
      if (!patron.test(nodo.nodeValue)) return;
      patron.lastIndex = 0;
      const span = document.createElement('span');
      span.innerHTML = nodo.nodeValue.replace(patron, '<mark class="resaltado-busqueda-prestia">$1</mark>');
      nodo.replaceWith(span);
      return;
    }
    if (nodo.nodeType !== Node.ELEMENT_NODE) return;
    if (nodo.tagName === 'MARK' || nodo.tagName === 'SCRIPT' || nodo.tagName === 'STYLE') return;
    [...nodo.childNodes].forEach(resaltarEnNodo);
  }

  function resaltarResultados() {
    document.querySelectorAll('.m-product-card__info').forEach((card) => {
      if (card.dataset.resaltadoAplicado) return;
      card.dataset.resaltadoAplicado = '1';
      resaltarEnNodo(card);
    });
  }

  if (!document.getElementById('estilo-resaltado-busqueda-prestia')) {
    const estilo = document.createElement('style');
    estilo.id = 'estilo-resaltado-busqueda-prestia';
    estilo.textContent = 'mark.resaltado-busqueda-prestia{background:#ffe066;color:inherit;padding:0 2px;border-radius:2px;}';
    document.head.appendChild(estilo);
  }

  resaltarResultados();
  new MutationObserver(resaltarResultados).observe(document.body, { childList: true, subtree: true });
})();

// ============================================================
// PRESTIA -- boton de lupa del rediseno de card (31/08/2026)
// No abre nada propio: dispara el click sobre el boton de vista rapida
// que el tema YA tenia (.m-product-quickview-button, oculto con
// display:none pero funcional -- ver assets/quickview-bridge.js).
// Asi la lupa usa el mismo modal probado, no una implementacion nueva.
// ============================================================
(function () {
  document.addEventListener('click', function (ev) {
    const boton = ev.target.closest('.js-prestia-quickview');
    if (!boton) return;
    const card = boton.closest('.m-product-card, .m-product-card__info');
    const ojito = card && card.parentElement
      ? card.parentElement.querySelector('.m-product-quickview-button')
      : null;
    const real = ojito || (card && card.querySelector('.m-product-quickview-button'));
    if (real) {
      real.removeAttribute('disabled');
      real.classList.remove('is-busy', 'm:hidden');
      ['click', 'pointerup'].forEach((tipo) => {
        real.dispatchEvent(new Event(tipo, { bubbles: true, cancelable: true }));
      });
    }
  }, true);
})();
